import React from "react";
import moment from "moment";
import IoMdEdit from "react-icons/lib/io/edit";
import IoMdTrash from "react-icons/lib/io/trash-a";

import { ConfirmationDialog, PureModal, Spinner } from "components/ui";

import * as msg from "actions/message";
import { useDispatch } from "react-redux";

const TableRow = row => {
  const {
    Id,
    SerialNumber,
    Source,
    ImportedDate,
    UsageDate,
    Usage,
    Pressure,
    P95,
    AHI,
    Leak,
    CreatedBy,
    CanEdit,
    onEdit,
    onDelete,
    isDeleting,
    userRole
  } = row;

  const dispatch = useDispatch();

  const handleDelete = async () => {
    const response = await onDelete(Id);
    if (response?.success) {
      dispatch(msg.message(response?.message ?? "Entry Deleted succesfully"));
      document.getElementById("manuallyRefreshTherapyData")?.click();
    }
  };

  const canUserEditDeleteManualEntry = [
    "Administrator",
    "SaasCompanyAdmin",
    "OfficeAdministrator",
    "SaasOfficeAdministrator",
    "SaasSleepCoach"
  ].includes(userRole);

  function formatUsage(minutes) {
    if (!minutes && minutes !== 0) return "";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  }

  return (
    <tr>
      <td>{SerialNumber}</td>
      <td style={{ textTransform: "capitalize" }}>{Source}</td>
      <td>{moment(ImportedDate).format("MM/DD/YYYY")}</td>
      <td>{moment(UsageDate).format("MM/DD/YYYY")}</td>
      <td>{formatUsage(Usage)}</td>
      <td>{Pressure}</td>
      <td>{P95}</td>
      <td>{AHI}</td>
      <td>{Leak}</td>
      <td>{CreatedBy}</td>

      {CanEdit && canUserEditDeleteManualEntry && (
        <td>
          {isDeleting ? (
            <Spinner />
          ) : (
            <>
              <IoMdEdit
                size={24}
                onClick={onEdit}
                style={{ cursor: "pointer", marginRight: "12px" }}
              />
              <PureModal
                renderTrigger={({ openModal }) => (
                  <IoMdTrash
                    size={24}
                    onClick={openModal}
                    style={{ cursor: "pointer", color: "red" }}
                  />
                )}
                renderContent={({ closeModal }) => (
                  <ConfirmationDialog
                    warningMsg="Are you sure you want to delete this record?"
                    continueMsg="Yes"
                    cancelMsg="Not Now"
                    onCancel={closeModal}
                    onConfirm={handleDelete}
                    isFetching={isDeleting}
                    cancelButtonStyles="button alert"
                  />
                )}
              />
            </>
          )}
        </td>
      )}
    </tr>
  );
};
export default TableRow;
